import React from "react";
import ContainerPhotosDialog from "@/src/components/organism/ContainerPhotosDialog";
import { DialogState } from "@/src/hooks/useShipmentDialogState";

interface ShipmentDialogsProps {
  dialogState: DialogState;
  containerIdForDialog?: number;
  loadingIds: number[];
  onClose: () => void;
}

const ShipmentDialogs: React.FC<ShipmentDialogsProps> = ({
  dialogState,
  containerIdForDialog,
  loadingIds,
  onClose,
}) => {
  if (dialogState === DialogState.NULL) return null;

  if (
    dialogState === DialogState.CONTAINER_PHOTO_DIALOG &&
    containerIdForDialog
  ) {
    return (
      <ContainerPhotosDialog
        open
        onClose={onClose}
        params={{ mode: "exporter-single", containerId: containerIdForDialog }}
      />
    );
  }

  if (dialogState === DialogState.ALL_CONTAINER_PHOTO_DIALOG) {
    return (
      <ContainerPhotosDialog
        open
        onClose={onClose}
        params={{ mode: "exporter-task", taskIds: loadingIds }}
      />
    );
  }

  return null;
};

export default ShipmentDialogs;
